<div class="chat-shell">
<div #scrollArea class="chat-scroll">
<div *ngFor="let m of messages" class="msg-row" [class.user]="m.role==='user'" [class.assistant]="m.role==='assistant'">
<div class="avatar" aria-hidden="true">{{ m.role==='user' ? '👤' : '🤖' }}</div>
<div class="msg-bubble" [class.pending]="m.pending">
<div class="msg-html" [innerHTML]="m.html"></div>
</div>
</div>
</div>


<div class="prompt-gradient" *ngIf="showTopShadow"></div>


<div #promptWrapper class="prompt-wrapper">
<div class="prompt-inner">
<div class="prompt-bar" role="group" aria-label="Chat prompt">
<button class="icon-btn" aria-label="Add attachment">
<svg viewBox="0 0 24 24" class="icon"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/></svg>
</button>


<textarea #promptInput
class="prompt-input"
rows="1"
placeholder="Send a message"
[(ngModel)]="draft"
(input)="autoGrow(promptInput)"
(keydown)="onKeyDown($event)"></textarea>


<button class="icon-btn" aria-label="Voice input" disabled>
<svg viewBox="0 0 24 24" class="icon">
<path d="M12 3a3 3 0 013 3v6a3 3 0 11-6 0V6a3 3 0 013-3z" fill="currentColor"/>
<path d="M5 11a7 7 0 0014 0M12 18v3" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/>
</svg>
</button>


<button class="send-btn" [class.active]="!!draft.trim()" aria-label="Send" (click)="send()">
<svg viewBox="0 0 24 24" class="send-icon"><path d="M5 12l14-7-4 14-3-5-7-2z" fill="currentColor"/></svg>
</button>
</div>
<div class="hint">Press <kbd>Enter</kbd> to send • <kbd>Shift</kbd>+<kbd>Enter</kbd> for a new line</div>
</div>
</div>
</div>